// extracted by mini-css-extract-plugin
export var root = "LimwOpVqoD0t5AHSEpNn";
export var senderCard = "OTwBmi8GYofgykuhXrDo";
export var senderLabel = "hLNf2OJ0uRqTtNesQnQH";
export var senderOptionAddress = "CPr6uFZrmK3P02MfX0lq";
export var senderOptionLabel = "BPYwMssf4TSiBlSrJe07";
export var widgetCard = "QOxzc6aS6TzbC_G_IwYL";